module.exports = __webpack_public_path__ + "static/img/tbLogo.a50d13ec.jpg";